import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { actions } from '../../features/myDesign';
import { QRSource } from '../../lib/QrReader';
import { getQueryParam, throttle } from '../../lib/utils';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';
import { NormalButton } from '../shared/buttons/NormalButton';
import { Dialog } from '../shared/dialog/Dialog';

export const OverwriteMyDesignDialog: React.FC = () => {
  const { t } = useTranslation(['my_design', 'translation']);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const source = getQueryParam(location.search, 'source') as QRSource;

  const handleOverwriteClick = useCallback(
    throttle(() => {
      dispatch(actions.readMyDesign(source));
      history.goBack();
    }, 1000),
    [dispatch]
  );

  const handleCancelClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [history]
  );

  return (
    <Dialog hasHeader={true} title={t('translation:dialog_warning')}>
      <div
        className={css`
          .message {
            min-height: 120px;
            padding: 12px 0 20px;
          }
          .buttons {
            button {
              margin: 12px 0 0;
            }
            button:nth-child(2) {
              margin-bottom: 4px;
            }
          }
          .delete-failed {
            color: #e60012;
            margin: 14px 0 0;
            text-align: center;
          }
        `}
      >
        <p className="message">{t('warn_overwrite')}</p>
        <div className="buttons">
          <ConfirmButton onClick={handleOverwriteClick}>
            {t('translation:dialog_button_ok')}
          </ConfirmButton>
          <NormalButton onClick={handleCancelClick}>
            {t('translation:dialog_button_cancel')}
          </NormalButton>
        </div>
      </div>
    </Dialog>
  );
};
